import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FaPlus, FaRegStar, FaStar, FaTimes, FaChevronLeft, FaChevronRight, FaRegSave } from "react-icons/fa";
import Rating from 'react-rating';
import { useDispatch } from 'react-redux';
import { deleteReview, updateReviewReply } from '../features/orders/orderSlice';
import { useMemo } from 'react';


function ReviewComponent({ product }) {
    const dispatch = useDispatch();
    const [reviewOpen, setReviewOpen] = useState(false);
    const [showAllReviews, setShowAllReviews] = useState(false); // State to toggle showing all reviews
    const reviews = product.reviews || [];

    const [displayedReviews, setDisplayedReviews] = useState(reviews.slice(0, 4));

    const [adminAccount, setAdminAccount] = useState(false);

    const { user } = useSelector((state) => state.auth);

    useEffect(() => {
      if (user && user.type === 'admin') {
        setAdminAccount(true);
      }
    }, [user]);
    

    const images = useMemo(() => {
        return product.reviews.flatMap((review) => review.images) || [];
    }, [product.reviews]);

    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        };

    
    const [imageIndex, setImageIndex] = useState(0);
    const [displayedImages, setDisplayedImages] = useState(images.slice(0, 10));
    const [imagesPerRow, setImagesPerRow] = useState(2); // Default to 2 images per row

    // Function to update the number of images per row based on screen width
    const updateImagesPerRow = () => {
        const screenWidth = window.innerWidth;
        if (screenWidth > 1350) {
            setImagesPerRow(10);
        } else if (screenWidth > 1000) {
            setImagesPerRow(8);
        } else if (screenWidth > 800) {
            setImagesPerRow(6);
        } else if (screenWidth > 500) {
            setImagesPerRow(4);
        } else {
            setImagesPerRow(2);
        }
    };

    // Use an effect to listen for window resize events
    useEffect(() => {
        updateImagesPerRow(); // Set the initial value
        window.addEventListener('resize', updateImagesPerRow); // Update on resize
        return () => window.removeEventListener('resize', updateImagesPerRow); // Cleanup on unmount
    }, []);

    useEffect(() => {
        setDisplayedImages(images.slice(imageIndex, imageIndex + imagesPerRow));
    }, [imageIndex, imagesPerRow, images]);
    

    const handlePrevGallery = () => {
        setImageIndex((prev) => Math.max(prev - imagesPerRow, 0));
    };
    
    const handleNextGallery = () => {
        setImageIndex((prev) => {
            const maxIndex = images.length - imagesPerRow;
            return Math.min(prev + imagesPerRow, maxIndex);
        });
    };

    const handleDeleteReview = (reviewId) => {
        const userConfirmed = window.confirm("Vai tiešām vēlaties izdzēst atsauksmi?");
        if (userConfirmed) {
            dispatch(deleteReview(reviewId));
            setDisplayedReviews(reviews.filter((review) => review._id !== reviewId));
        }
    }

    const handleClickShowAll = () => {
        const currentLength = displayedReviews.length;
        const newLength = Math.min(currentLength + 4, reviews.length); // Ensure it doesn't exceed the total number of reviews
        setDisplayedReviews(reviews.slice(0, newLength));
    };

    const [galleryImages, setGalleryImages] = useState([]);
    const [galleryOpen, setGalleryOpen] = useState(false);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [currentImage, setCurrentImage] = useState(null);

    const startGallery = (images) => {
        setGalleryImages(images);
        setGalleryOpen(true);
        setCurrentImageIndex(0);
        setCurrentImage(images[0]);
    }

    const imageLeft = () => {
        setCurrentImageIndex((prevIndex) => {
            const newIndex = (prevIndex - 1 + galleryImages.length) % galleryImages.length;
            setCurrentImage(galleryImages[newIndex]); // Update the current image based on the new index
            return newIndex;
        });
    };
    
    const imageRight = () => {
        setCurrentImageIndex((prevIndex) => {
            const newIndex = (prevIndex + 1) % galleryImages.length;
            setCurrentImage(galleryImages[newIndex]); // Update the current image based on the new index
            return newIndex;
        });
    };

    const closeGallery = () => {
        setGalleryOpen(false);
        setCurrentImage(null);
        setCurrentImageIndex(0);
        setGalleryImages([]);
    }

    const [touchStartX, setTouchStartX] = useState(0);
    const [touchEndX, setTouchEndX] = useState(0);

    const handleTouchStart = (e) => {
        setTouchStartX(e.touches[0].clientX); // Record the starting X position of the touch
    };

    const [swipeDirection, setSwipeDirection] = useState(""); // State for swipe direction

    const handleTouchMove = (e) => {
        setTouchEndX(e.touches[0].clientX); // Update the current X position of the touch
    };

    const handleTouchEnd = () => {
        if (touchStartX - touchEndX > 80) {
            // Swipe left
            setSwipeDirection("left");
            imageRight();
        } else if (touchEndX - touchStartX > 80) {
            // Swipe right
            setSwipeDirection("right");
            imageLeft();
        }
        // Reset touch positions
        setTouchStartX(0);
        setTouchEndX(0);

        // Remove the swipe animation class after the animation completes
        setTimeout(() => setSwipeDirection(""), 300); // Match the animation duration
    };

    const getReplyReviewObject = (reply) => {
        return {
            "_id": "67fea8021d4eaa13ecbfc242",
            "order_id": "66a4fe59884a0382d55d7d7d",
            "product_id": "66966c22d7fdc83b66a3236e",
            "variation_id": "66966c22d7fdc83b66a3236f",
            "author": "Nora Spora",
            "review": reply
        };
    };

    const [replies, setReplies] = useState(
        reviews.reduce((acc, review) => {
            acc[review._id] = review.reply || ""; // Initialize with existing replies
            return acc;
        }, {})
    );

    const handleReplyChange = (reviewId, newReply) => {
        setReplies((prevReplies) => ({
            ...prevReplies,
            [reviewId]: newReply, // Update the reply for the specific review
        }));
    };

    const handleSaveReply = (reviewId) => {
        const updatedReply = replies[reviewId];
        dispatch(updateReviewReply({
            reviewId,
            reply: updatedReply
        }))
        // Add logic to save the reply to the backend (e.g., via an API call)
    };

    if(!product || !product.reviews || product.reviews.length === 0) {
        return null
    }

    const totalReviews = Object.values(product.review_counts).reduce((acc, val) => acc + val, 0); // Calculate total reviews
    const currentLang = localStorage.getItem('lang') || 'lv';

    return (
        
        <div className="review-component padding-20-top">
            {galleryOpen && 
                <div
                    className="review-popup-gallery"
                    onTouchStart={handleTouchStart}
                    onTouchMove={handleTouchMove}
                    onTouchEnd={handleTouchEnd}
                >
                    <div className="control" onClick={() => imageLeft()}>
                        <FaChevronLeft size={20} color="white" />
                    </div>
                    <div className={`current-image swipe-${swipeDirection}`}>
                        <img src={currentImage.src} alt="Current" />
                        <div className="close" onClick={() => closeGallery()}>
                            <FaTimes size={20} color="white"  />
                        </div>
                    </div>
                    <div className="control" onClick={() => imageRight()}>
                        <FaChevronRight size={20} color="white" />
                    </div>
                </div>
            }
            
            <h2 className="light">
                {currentLang === 'en' ? "Customer Reviews" : "Atsauksmes"}
            </h2>
            
            <div className="review-area padding-10-top padding-10-bottom">
                <div className="flex gap-5 align-center gap-10">
                    <Rating
                        emptySymbol={<FaRegStar style={{ cursor: 'pointer' }} size={15} color="#ffc000" />}
                        fullSymbol={<FaStar style={{ cursor: 'pointer' }} size={15} color="#ffc000" />}
                        initialRating={product.rating || 0}
                        readonly
                    />
                    <h2 className="light">
                        {product.rating}
                    </h2>
                </div>
                <p style={{marginTop:'-20px'}}>{totalReviews} {currentLang === 'en' ? "reviews" : "atsauksmes"}</p>
                
            <div className="review-counts">
                
            {Object.entries(product.review_counts)
                .reverse() // Reverse the order of the entries
                .map(([rating, count]) => {
                    const totalReviews = Object.values(product.review_counts).reduce((acc, val) => acc + val, 0); // Calculate total reviews
                    const percentage = totalReviews > 0 ? (count / totalReviews) * 100 : 0; // Calculate percentage

                    return (
                        <div key={rating} className="review-count">
                            <Rating
                                emptySymbol={<FaRegStar style={{ cursor: 'pointer' }} size={15} color="#ffc000" />}
                                fullSymbol={<FaStar style={{ cursor: 'pointer' }} size={15} color="#ffc000" />}
                                initialRating={rating}
                                readonly
                            />
                            <div className="load-bar">
                                <div
                                    className="load-bar-content"
                                    style={{ width: `${percentage}%` }} // Set dynamic width
                                ></div>
                            </div>
                            <span>{count}</span>
                        </div>
                    );
                })}
            </div>
                
                {displayedReviews.map((review, index) => (
                    <>
                        <div className="review-card" key={index}>
                            {adminAccount && 
                                <div className="admin-actions-review flex gap-10">
                                    <div className="delete-review" onClick={() => handleDeleteReview(review._id)}>
                                        <FaTimes size={20} color='red'/>
                                    </div>
                                    <div className="delete-review" onClick={() => handleSaveReply(review._id)}>
                                        <FaRegSave size={20} color='black'/>
                                    </div>
                                </div>
                                
                            }
                            
                            <div className="review-area-header">
                                <span>{review.author} ({new Date(review.date_completed).toLocaleDateString("lv-LV", {
                                    year: "numeric",
                                    month: "2-digit",
                                    day: "2-digit",
                                })})</span>
                                <Rating
                                    emptySymbol={<FaRegStar style={{cursor:'pointer'}} size={15} color="#ffc000" />}
                                    fullSymbol={<FaStar style={{cursor:'pointer'}} size={15} color="#ffc000" />}
                                    initialRating={review.rating}
                                    readonly
                                />
                            </div>
                            {review.review && review.review.length > 0 &&
                                <>
                                    <div className="review-text-area">
                                        <p className={`review-text ${review.reply && review.reply.length > 0 ? 'has-reply' : ''}`}>
                                            {review.review}
                                        </p>
                                    </div>
                                    {adminAccount ? (
                                        // Admin view: Always show the reply area
                                        <div className="admin-add-edit-reply">
                                            <textarea
                                                value={replies[review._id]} // Bind to the specific reply
                                                onChange={(e) => handleReplyChange(review._id, e.target.value)} // Update reply for this review
                                                name={`reply-${review._id}`}
                                                id={`reply-${review._id}`}
                                            ></textarea>
                                        </div>
                                    ) : (
                                        // Non-admin view: Only show the reply if it exists
                                        review.reply && review.reply.length > 0 && (
                                            <div className="review-reply-area">
                                                <span className="review-text has-reply">
                                                    <p><b>Nora Spora:</b></p>
                                                    <p>{review.reply}</p>
                                                </span>
                                            </div>
                                        )
                                    )}
                                </>
                            }
                            {review.images && review.images.length > 0 &&
                                <div className="product-review-gallery">
                                    {review.images &&
                                        review.images.map((image, idx) => (
                                            <div className="review-gallery-image" key={idx}>
                                                <img src={image.src} alt={`Review image ${idx}`} onClick={() => startGallery(review.images)}/>
                                            </div>
                                    ))}
                                </div>
                            }
                            
                        </div>
                    </>
                ))}
                
            </div>
            {displayedReviews.length < reviews.length && (
                <button
                    className="show-more-button"
                    onClick={handleClickShowAll}
                >
                    <FaPlus size={15} />
                    {displayedReviews.length < reviews.length ? "Rādīt vairāk" : "Rādīt mazāk"}
                </button>
            )}
        </div>
    );
}

export default ReviewComponent;